import { render, staticRenderFns } from "./CmEmbarcadorRiskMatrixChart.vue?vue&type=template&id=385b173d&scoped=true&"
import script from "./CmEmbarcadorRiskMatrixChart.vue?vue&type=script&lang=js&"
export * from "./CmEmbarcadorRiskMatrixChart.vue?vue&type=script&lang=js&"
import style0 from "./CmEmbarcadorRiskMatrixChart.vue?vue&type=style&index=0&id=385b173d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b173d",
  null
  
)

export default component.exports